import React from "react";
import { useOrder } from "../state/order";
import { useBasketUI } from "../state/basketUi";
import type { Toy } from "../services/api";

interface OrderModalProps {
  open: boolean;
  onClose: () => void;
  justAdded?: { toy: Toy; quantity?: number } | null;
}

const OrderModal: React.FC<OrderModalProps> = ({
  open,
  onClose,
  justAdded,
}) => {
  const { items, totalPoints } = useOrder();
  const { openBasket } = useBasketUI();

  if (!open) return null;

  return (
    <div className="fixed top-4 right-4 z-50">
      <div className="w-[320px] bg-white border border-gray-200 rounded-lg shadow-lg overflow-hidden">
        <div className="px-4 py-3 border-b flex items-center justify-between">
          <div className="text-sm font-semibold text-gray-900">
            Added to your order
          </div>
          <button
            aria-label="Close"
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            ✕
          </button>
        </div>

        <div className="px-4 py-3">
          {justAdded && (
            <div className="flex items-center gap-3 mb-3">
              <img
                src={justAdded.toy.images?.[0] || ""}
                alt={justAdded.toy.name}
                className="w-10 h-10 rounded object-cover"
              />
              <div>
                <div className="font-medium text-gray-900 truncate">
                  {justAdded.toy.name}
                </div>
                <div className="text-xs text-gray-600">
                  {justAdded.quantity ?? 1} × {justAdded.toy.points} pts
                </div>
              </div>
            </div>
          )}

          <div className="text-sm text-gray-700">
            You now have <span className="font-semibold">{items.length}</span>{" "}
            item
            {items.length === 1 ? "" : "s"} in your order.
          </div>
          <div className="text-sm text-gray-700">
            Current total:{" "}
            <span className="font-semibold">{totalPoints} pts</span>
          </div>

          <div className="mt-3 flex gap-2 justify-center">
            <button
              onClick={() => {
                onClose();
                openBasket();
              }}
              className="px-3 py-1.5 rounded-md bg-brand-600 text-white hover:bg-brand-700 text-sm"
            >
              Review basket
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderModal;
